import { Footer } from "../components/Footer"
import { GenericMethods } from "../components/deposit/GenericMethods"


export const DepositGenericPage = () => {
    return (
        <div className="container">
            <GenericMethods />
            <Footer />
        </div>
    );
}